<template>

    <ui-modal
        class="action-detail-modal"
        :title="action.__typename | actionTypeTitle(action)"
        :padding="false"
        @close="cancel">

        <ui-view-panel>
            <tr>
                <td class="key">Datum</td>
                <td>{{ action.date | date("LL") }}</td>
            </tr>
            <tr v-if="isKeyAvailable('ship') && action.ship">
                <td class="key">Schip</td>
                <td>{{ action.ship.name }}</td>
            </tr>
            <tr>
                <td class="key">Actie</td>
                <td>{{ actionType | actionTypeTitle(action) }}</td>
            </tr>
            <tr v-if="isKeyAvailable('originLocation')">
                <td class="key">Oorsprong</td>
                <td>{{ action.originLocation | empty }} {{ action.originType | originType }} {{ action.seedYear }}</td>
            </tr>
            <tr v-if="isKeyAvailable('mziArea')">
                <td class="key">MZI gebied</td>
                <td>{{ action.mziArea | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('duration')">
                <td class="key">MZI: Aantal uur gevist</td>
                <td>{{ action.duration | number | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('fishingArea')">
                <td class="key">Visgebied</td>
                <td>{{ action.fishingArea | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('fishingWeight')">
                <td class="key">Visgewicht</td>
                <td>{{ action.fishingWeight | empty }}</td>
            </tr>
            <tr v-if="action.originParcel">
                <td class="key">Herkomst perceel</td>
                <td>
                    <template v-if="action.originParcel.alias != null">{{ action.originParcel.alias }}</template>
                    <template v-else>{{ action.originParcel.parcelLocation.name }} {{ action.originParcel.parcelLocation.number }}</template>
                </td>
            </tr>
            <tr v-if="isKeyAvailable('brutoWeight')">
                <td class="key">Bruto</td>
                <td>{{ action.brutoWeight | number | empty }} mTon</td>
            </tr>
            <tr v-if="isKeyAvailable('nettoWeight')">
                <td class="key">Netto</td>
                <td>{{ action.nettoWeight | number | empty }} mTon</td>
            </tr>
            <tr v-if="isKeyAvailable('brutoWeight')">
                <td class="key">Gewicht</td>
                <td>{{ action.brutoWeight * 100 | number | empty }} kg</td>
            </tr>
            <tr v-if="isKeyAvailable('tarra')">
                <td class="key">Tarra</td>
                <td>{{ action.tarra | number | empty }}%</td>
            </tr>
            <tr v-if="isKeyAvailable('bustal')">
                <td class="key">Bustal</td>
                <td>{{ action.bustal | number | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('stukstal')">
                <td class="key">Stukstal</td>
                <td>{{ action.stukstal | number | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('brutoWeight') || isKeyAvailable('nettoWeight')">
                <td class="key">Zaaidichtheid</td>
                <td>{{ (action.brutoWeight || action.nettoWeight) / section.size | number | empty }} mTon/ha</td>
            </tr>
            <tr v-if="action.sowingSection">
                <td class="key">Doel</td>
                <td>Verzaaid naar {{ action.sowingSection.parcel | parcel }}, Vak: {{ action.sowingSection.name }}</td>
            </tr>
            <tr v-else>
                <td class="key">Doel</td>
                <td>{{ action.__typename | actionTypeTitle(action) }} op {{ parcel | parcel }}, Vak: {{ section.name }}
                </td>
            </tr>
            <tr v-if="isKeyAvailable('fishingDuration') && action.fishingDuration != null">
                <td class="key">Visuren</td>
                <td>{{ action.fishingDuration.duration | number | empty }} min</td>
            </tr>
            <tr v-if="isKeyAvailable('notes')">
                <td class="key">Bijzonderheden</td>
                <td>{{ action.notes | empty }}</td>
            </tr>
            <tr v-if="isKeyAvailable('emptied')">
                <td class="key">Leeggevist</td>
                <td>{{ action.emptied | bool }}</td>
            </tr>
        </ui-view-panel>

        <div v-if="treatment">
            <h3>Behandeling</h3>
            <ui-view-panel>
                <tr>
                    <td class="key">Behandeling</td>
                    <td>{{ treatment.treatment | empty }}</td>
                </tr>
                <tr>
                    <td class="key">Duur</td>
                    <td>{{ treatment.duration | number | empty }} uur</td>
                </tr>
                <tr>
                    <td class="key">Bijzonderheden</td>
                    <td>{{ treatment.notes | empty }}</td>
                </tr>
            </ui-view-panel>
        </div>

        <ui-panel class="images-panel" v-if="action.actionImages?.items?.length > 0">
            <h2 class="title">Foto's</h2>

            <div class="image-container">
                <img
                    class="image"
                    :src="n.url"
                    v-for="(n, index) in action.actionImages.items"
                    @click="openPhotoViewer(action, n, index)"/>
            </div>
        </ui-panel>

    </ui-modal>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import dismissalMixin from 'js-core/js/mixins/dismissal';

import PhotoViewerPanel from 'app/components/panels/PhotoViewerPanel.vue';

@Component({

    name: 'ActionDetailModal',
    mixins: [dismissalMixin],
    props: ['action', 'section', 'parcel', 'treatment']
})
export default class ActionDetailModal extends Vue {

    isKeyAvailable(key) {

        return this.keysByActionType[this.actionType].indexOf(key) >= 0;
    }

    get keysByActionType() {

        return {
            'Harvest': ['cohortId', 'sowingId', 'ship', 'date', 'brutoWeight', 'nettoWeight', 'tarra', 'bustal', 'stukstal', 'fishingWeight', 'emptied', 'notes', 'fishingDuration'],
            'Sample': ['cohortId', 'ship', 'date', 'bustal', 'stukstal', 'fishingWeight', 'notes', 'fishingDuration'],
            'Sowing': ['cohortId', 'shipId', 'ship', 'date', 'seedType', 'originLocation', 'originType', 'fishingArea', 'mziArea', 'seedYear', 'brutoWeight', 'nettoWeight', 'tarra', 'bustal', 'stukstal', 'notes', 'duration', 'fishingDuration'],
            'Treatment': ['userId', 'cohortId', 'ship', 'date', 'treatment', 'duration', 'sowingId', 'harvestId', 'notes', 'fishingDuration']
        };
    }

    get actionType() {

        return this.action.__typename;
    }

    openPhotoViewer(action, image, index){
        this.$modal(PhotoViewerPanel, {
            action,
            image,
            section: this.section,
            index
        });
    }
}

</script>